import { createNoteTakerSttTranscriptProvider } from './noteTakerSttTranscriptProvider'
import { createMockTranscriptProvider } from './noteTakerMockTranscriptProvider'

/**
 * Returns the active transcript provider implementation.
 * Mock is available only when REACT_APP_NOTE_TAKER_MOCK_TRANSCRIPT=true.
 */
export function createTranscriptProvider({ store }) {
	if (process.env.REACT_APP_NOTE_TAKER_MOCK_TRANSCRIPT === 'true') {
		return createMockTranscriptProvider({
			onUpdate: text => store.setLiveTranscript(text),
		})
	}

	return createNoteTakerSttTranscriptProvider({ store })
}
